/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateSensor = /* GraphQL */ `
  subscription OnCreateSensor($filter: ModelSubscriptionSensorFilterInput) {
    onCreateSensor(filter: $filter) {
      id
      apiGroupId
      groupId
      managementId
      name
      status
      lat
      lng
      location
      description
      tx
      isLocked
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateSensor = /* GraphQL */ `
  subscription OnUpdateSensor($filter: ModelSubscriptionSensorFilterInput) {
    onUpdateSensor(filter: $filter) {
      id
      apiGroupId
      groupId
      managementId
      name
      status
      lat
      lng
      location
      description
      tx
      isLocked
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteSensor = /* GraphQL */ `
  subscription OnDeleteSensor($filter: ModelSubscriptionSensorFilterInput) {
    onDeleteSensor(filter: $filter) {
      id
      apiGroupId
      groupId
      managementId
      name
      status
      lat
      lng
      location
      description
      tx
      isLocked
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateSensorGroup = /* GraphQL */ `
  subscription OnCreateSensorGroup(
    $filter: ModelSubscriptionSensorGroupFilterInput
  ) {
    onCreateSensorGroup(filter: $filter) {
      id
      name
      type
      messages {
        status
        message
        color
        value
        notification
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateSensorGroup = /* GraphQL */ `
  subscription OnUpdateSensorGroup(
    $filter: ModelSubscriptionSensorGroupFilterInput
  ) {
    onUpdateSensorGroup(filter: $filter) {
      id
      name
      type
      messages {
        status
        message
        color
        value
        notification
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteSensorGroup = /* GraphQL */ `
  subscription OnDeleteSensorGroup(
    $filter: ModelSubscriptionSensorGroupFilterInput
  ) {
    onDeleteSensorGroup(filter: $filter) {
      id
      name
      type
      messages {
        status
        message
        color
        value
        notification
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateNotification = /* GraphQL */ `
  subscription OnCreateNotification(
    $filter: ModelSubscriptionNotificationFilterInput
  ) {
    onCreateNotification(filter: $filter) {
      id
      startDate
      endDate
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateNotification = /* GraphQL */ `
  subscription OnUpdateNotification(
    $filter: ModelSubscriptionNotificationFilterInput
  ) {
    onUpdateNotification(filter: $filter) {
      id
      startDate
      endDate
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteNotification = /* GraphQL */ `
  subscription OnDeleteNotification(
    $filter: ModelSubscriptionNotificationFilterInput
  ) {
    onDeleteNotification(filter: $filter) {
      id
      startDate
      endDate
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCameraTrafficVolume = /* GraphQL */ `
  subscription OnCreateCameraTrafficVolume(
    $filter: ModelSubscriptionCameraTrafficVolumeFilterInput
  ) {
    onCreateCameraTrafficVolume(filter: $filter) {
      cameraId
      timestamp
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCameraTrafficVolume = /* GraphQL */ `
  subscription OnDeleteCameraTrafficVolume(
    $filter: ModelSubscriptionCameraTrafficVolumeFilterInput
  ) {
    onDeleteCameraTrafficVolume(filter: $filter) {
      cameraId
      timestamp
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
